import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import usePageStylesheet from '../util/use-page-stylesheet';
import EyesNav from '../components/EyesNav';

/**
 * The video archive, ported 1:1 from eyes/videos.html. See Splash.js — the
 * same arrangement applies here: original markup, original stylesheet at
 * public/eyes/watch.css, original inline scripts as effects.
 */
export default function Watch() {
  usePageStylesheet('/eyes/watch.css');

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Watch | The Eyes Are Always Watching';

    const cleanups = [() => (document.title = previousTitle)];

    // ===== video-library-js =====
    (() => {
      const player = document.getElementById('mainVideo');
      const source = document.getElementById('mainSource');
      if (!player || !source) return;

      const choices = [...document.querySelectorAll('.video-choice')];
      const handlers = choices.map((btn) => {
        const onClick = () => {
          choices.forEach((x) => x.classList.remove('active'));
          btn.classList.add('active');
          const wasPlaying = !player.paused;
          source.src = btn.dataset.src;
          player.poster = btn.dataset.poster;
          player.load();
          player.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (wasPlaying) player.play().catch(() => {});
        };
        btn.addEventListener('click', onClick);
        return [btn, onClick];
      });

      cleanups.push(() =>
        handlers.forEach(([btn, onClick]) =>
          btn.removeEventListener('click', onClick),
        ),
      );
    })();


    return () => cleanups.forEach((fn) => fn());
  }, []);

  return createPortal(
    <>
      <EyesNav />
      {' '}
      <header className="video-page-intro">
        {' '}
        <div className="wrap">
          {' '}
          <div className="eyebrow">
            VIDEO ARCHIVE
          </div>
          {' '}
          <h1>
            LEARN THE STORY
          </h1>
          {' '}
        </div>
        {' '}
      </header>
      {' '}
      <main className="watch-library">
        {' '}
        <div className="wrap">
          {' '}
          <div className="main-player">
            {' '}
            <video id="mainVideo" controls playsInline preload="metadata" poster="/eyes/posters/video-01.jpg">
              {' '}
              <source id="mainSource" src="/eyes/videos/video-01.mp4" type="video/mp4" />
              {' '}
            </video>
            {' '}
          </div>
          {' '}
          <div className="library-bar">
            {' '}
            <span>
              ALL VIDEOS
            </span>
            {' '}
            <span>
              4 VIDEOS
            </span>
            {' '}
          </div>
          {' '}
          <div className="video-choices">
            {' '}
            <button className="video-choice active" data-index="0" data-src="/eyes/videos/video-01.mp4" data-poster="/eyes/posters/video-01.jpg">
              {' '}
              <span className="choice-thumb">
                <img src="/eyes/posters/video-01.jpg" alt="" />
                <span className="choice-play">
                  ▶
                </span>
              </span>
              {' '}
              <span className="choice-meta">
                <b>
                  VIDEO 01
                </b>
                <small>
                  01 / 04
                </small>
              </span>
              {' '}
            </button>
            {' '}
            <button className="video-choice" data-index="1" data-src="/eyes/videos/video-02.mp4" data-poster="/eyes/posters/video-02.jpg">
              {' '}
              <span className="choice-thumb">
                <img src="/eyes/posters/video-02.jpg" alt="" />
                <span className="choice-play">
                  ▶
                </span>
              </span>
              {' '}
              <span className="choice-meta">
                <b>
                  VIDEO 02
                </b>
                <small>
                  02 / 04
                </small>
              </span>
              {' '}
            </button>
            {' '}
            <button className="video-choice" data-index="2" data-src="/eyes/videos/video-03.mp4" data-poster="/eyes/posters/video-03.jpg">
              {' '}
              <span className="choice-thumb">
                <img src="/eyes/posters/video-03.jpg" alt="" />
                <span className="choice-play">
                  ▶
                </span>
              </span>
              {' '}
              <span className="choice-meta">
                <b>
                  VIDEO 03
                </b>
                <small>
                  03 / 04
                </small>
              </span>
              {' '}
            </button>
            {' '}
            <button className="video-choice" data-index="3" data-src="/eyes/videos/video-04.mp4" data-poster="/eyes/posters/video-04.jpg">
              {' '}
              <span className="choice-thumb">
                <img src="/eyes/posters/video-04.jpg" alt="" />
                <span className="choice-play">
                  ▶
                </span>
              </span>
              {' '}
              <span className="choice-meta">
                <b>
                  VIDEO 04
                </b>
                <small>
                  04 / 04
                </small>
              </span>
              {' '}
            </button>
          </div>
          {' '}
        </div>
        {' '}
      </main>
      {' '}
      <footer>
        <img src="/eyes/assets/776ab65b02.png" />
        <div className="foot">
          <a href="/#about">
            ABOUT
          </a>
          <a href="/#lore">
            LORE
          </a>
          <a href="/#why-ordinals">
            WHY ORDINALS
          </a>
          <a href="/#gallery">
            GALLERY
          </a>
          <a href="/watch">
            WATCH
          </a>
          <a href="#archive">
            WATCH
          </a>
          <a href="/#faq">
            FAQ
          </a>
        </div>
        <div className="copy">
          © 2026 THE EYES. ALL RIGHTS RESERVED.
        </div>
        <a className="eyes-footer-legal" href="/disclaimer">
          DISCLAIMER
        </a>
      </footer>
    </>,
    document.body,
  );
}
